
import MainR from './routes/MainR';

function App() {
  return (
      <div>
        
        <MainR/>
        
      </div>)
}

export default App;
